import React, { Component, Fragment } from 'react';
import { Form, Input, Icon, Button } from 'antd';

import styles from '../Form.module.css';

const { Item } = Form;

const WrappedForgotForm = Form.create()(
  class ForgotForm extends Component {
    render() {
      const { getFieldDecorator } = this.props.form;
      return (
        <Fragment>
          <Form className={styles.Form}>
            <span className={styles.Description}>
              Enter the email address associated with your account, and we'll send you a link to reset your password
            </span>
            <Item>
              {getFieldDecorator('email', {
                rules: [
                  { type: 'email', message: 'The input is not a valid E-mail' },
                  { required: true, message: 'Please input your email address' },
                ],
              })(<Input prefix={<Icon type="mail" className={styles.Input} />} placeholder="Your email here" />)}
            </Item>
            <Button type="primary" htmlType="submit" className={styles.Button}>
              Submit Password
            </Button>
          </Form>
        </Fragment>
      );
    }
  },
);

export default WrappedForgotForm;



// WEBPACK FOOTER //
// ./src/components/Forms/ForgotForm/ForgotForm.js